/* Braymont · state-driven transparent header. */
(() => {
  if (typeof window.__bmHeaderCleanup === 'function') window.__bmHeaderCleanup();
  const el = document.querySelector('.header-wrapper.bm-header-should-overlay');
  if (!el) return;
  const section = el.closest('.section-header');
  if (!section) return;
  section.classList.add('bm-header-overlay');
  let raf = 0;
  function update() {
    raf = 0;
    el.classList.toggle('bm-header-scrolled', window.scrollY > 8);
    el.classList.toggle('bm-header-interacting', !!el.querySelector('details[open]'));
    section.style.setProperty('--bm-overlay-height', Math.ceil(el.getBoundingClientRect().height) + 'px');
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(update); }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  const obs = new MutationObserver(schedule);
  obs.observe(el, {subtree:true,attributes:true,attributeFilter:['open']});
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  if (resize) resize.observe(el);
  update();
  window.__bmHeaderCleanup = () => {
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', schedule);
    obs.disconnect();
    if (resize) resize.disconnect();
    if (raf) cancelAnimationFrame(raf);
  };
})();